var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMobileMessage = function SvgMobileMessage(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.698 83.2899V117.728C103.698 118.704 102.899 119.503 101.923 119.503H53.1062C52.1299 119.503 51.3311 118.704 51.3311 117.728V42.1065C51.3311 41.1302 52.1299 40.3314 53.1062 40.3314H101.834C102.81 40.3314 103.609 41.1302 103.609 42.1065V62.9645",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0057 83.4674V96.6923H64.0234V56.2189H91.0057V63.2308",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3603 109.74C77.2427 109.74 77.958 109.024 77.958 108.142C77.958 107.26 77.2427 106.544 76.3603 106.544C75.478 106.544 74.7627 107.26 74.7627 108.142C74.7627 109.024 75.478 109.74 76.3603 109.74Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.561 83.2012H80.7981L74.9401 88.8817C74.5851 89.2367 73.875 88.9704 73.875 88.4379V83.2012V67.0473C73.875 65.3609 75.2951 63.9408 76.9815 63.9408H105.561C107.248 63.9408 108.668 65.3609 108.668 67.0473V80.0947C108.668 81.8698 107.248 83.2012 105.561 83.2012Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9285 74.7692C83.4677 74.7692 83.9048 74.3321 83.9048 73.7929C83.9048 73.2537 83.4677 72.8166 82.9285 72.8166C82.3893 72.8166 81.9521 73.2537 81.9521 73.7929C81.9521 74.3321 82.3893 74.7692 82.9285 74.7692Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1834 74.7692C91.7226 74.7692 92.1597 74.3321 92.1597 73.7929C92.1597 73.2537 91.7226 72.8166 91.1834 72.8166C90.6442 72.8166 90.207 73.2537 90.207 73.7929C90.207 74.3321 90.6442 74.7692 91.1834 74.7692Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4373 74.7692C99.9765 74.7692 100.414 74.3321 100.414 73.7929C100.414 73.2537 99.9765 72.8166 99.4373 72.8166C98.8981 72.8166 98.4609 73.2537 98.4609 73.7929C98.4609 74.3321 98.8981 74.7692 99.4373 74.7692Z",
    stroke: "#313E48",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 81.9231,
    fill: "white",
    transform: "translate(50 39)"
  })))));
};
export { SvgMobileMessage as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile-message.05712890.svg";